(function () {
  if (window.CAWelcomeDiscount) return;
  var CODE = /^\d{7}$/;
  var STATES = ['active', 'used', 'expired'];

  function cookieCode() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    var value = match ? decodeURIComponent(match[1]) : '';
    return CODE.test(value) ? value : '';
  }
  function read(key) { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function write(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }

  function lookup(code, endpoint) {
    var cached = read('ca-welcome-state');
    if (cached && cached.code === code && Date.now() - cached.at < 600000) return Promise.resolve(cached.state);
    return fetch(endpoint + '?code=' + encodeURIComponent(code), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : { state: 'unknown' }; })
      .then(function (data) {
        var state = STATES.indexOf(data && data.state) >= 0 ? data.state : 'unknown';
        if (state !== 'unknown') write('ca-welcome-state', { code: code, state: state, at: Date.now() });
        return state;
      })
      .catch(function () { return 'unknown'; });
  }

  var current = { code: cookieCode(), state: 'unknown' };
  var strings = {};
  var listeners = [];
  function notify() { listeners.forEach(function (fn) { fn(current); }); }

  function showFor(root, state) {
    root.querySelectorAll('[data-for]').forEach(function (el) {
      el.hidden = el.getAttribute('data-for').split(' ').indexOf(state) < 0;
    });
    root.querySelectorAll('[data-code]').forEach(function (el) { el.textContent = current.code; });
  }

  function markCart() {
    document.querySelectorAll('.cart-drawer-button').forEach(function (link) {
      var mark = link.querySelector('.ca-welcome-mark');
      if (current.state === 'active') {
        if (!mark) {
          mark = document.createElement('span');
          mark.className = 'ca-welcome-mark';
          mark.textContent = strings.mark || '10%';
          link.appendChild(mark);
        }
      } else if (mark) mark.remove();
    });
  }

  function decorateDrawer() {
    if (current.state !== 'active' && current.state !== 'used') return;
    document.querySelectorAll('.discounts .discount').forEach(function (line) {
      if (line.dataset.caWelcome) return;
      var spans = line.querySelectorAll('span');
      var title = spans[0];
      if (!title || title.textContent.trim() !== current.code) return;
      line.dataset.caWelcome = '1';
      line.classList.add('ca-welcome-line');
      var label = document.createElement('span');
      label.className = 'ca-welcome-line__label';
      var lead = document.createElement('b');
      lead.textContent = strings.applied || 'Welcome discount applied';
      var detail = document.createElement('small');
      detail.textContent = (strings.codeLine || 'Code %code%').replace('%code%', current.code);
      label.appendChild(lead);
      label.appendChild(detail);
      title.replaceWith(label);
      if (spans[1]) spans[1].classList.add('ca-welcome-line__amount');
    });
  }

  var scheduled = null;
  function scheduleDecorate() {
    if (scheduled) return;
    scheduled = setTimeout(function () { scheduled = null; decorateDrawer(); markCart(); }, 60);
  }

  function watchCart() {
    document.addEventListener('cart:updated', scheduleDecorate);
    document.addEventListener('ca:cart:updated', scheduleDecorate);
    document.addEventListener('cart:refresh', scheduleDecorate);
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) new MutationObserver(scheduleDecorate).observe(drawer, { childList: true, subtree: true });
    scheduleDecorate();
  }

  customElements.define('ca-welcome-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      var self = this;
      try { strings = JSON.parse(this.querySelector('[data-ca-welcome-strings]').textContent); } catch (e) {}
      this.querySelector('.ca-welcome-bar__close').addEventListener('click', function () {
        write('ca-welcome-dismissed', current.code);
        self.hidden = true;
      });
      if (!current.code) { notify(); return; }
      lookup(current.code, this.dataset.endpoint).then(function (state) {
        current.state = state;
        notify();
        watchCart();
        if (state === 'unknown' || read('ca-welcome-dismissed') === current.code) return;
        showFor(self, state);
        self.setAttribute('data-state', state);
        self.hidden = false;
      });
    }
  });

  function bindPage(page) {
    var apply = function () {
      var state = current.code ? current.state : 'none';
      if (state === 'unknown') state = 'none';
      page.setAttribute('data-state', state);
      showFor(page, state);
    };
    listeners.push(apply);
    apply();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ca-welcome-page]').forEach(bindPage);
  });
  if (document.readyState !== 'loading') document.querySelectorAll('[data-ca-welcome-page]').forEach(bindPage);

  window.CAWelcomeDiscount = {
    get code() { return current.code; },
    get state() { return current.state; },
    onChange: function (fn) { listeners.push(fn); fn(current); }
  };
})();
